"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponsiveLayout = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@bluebase/core");
const react_1 = tslib_1.__importDefault(require("react"));
const useScreenSize_1 = require("../../useScreenSize");
const ResponsiveLayout = (props) => {
    const { default: _default, lg, lgProps, md, mdProps, sm, smProps, xl, xlProps, xs, xsProps } = props, rest = tslib_1.__rest(props, ["default", "lg", "lgProps", "md", "mdProps", "sm", "smProps", "xl", "xlProps", "xs", "xsProps"]);
    if (!_default) {
        throw Error('A "default" component is required in ResponsiveLayout.');
    }
    const screenSize = useScreenSize_1.useScreenSize();
    const Component = core_1.useComponent(props[screenSize] || props.default);
    return react_1.default.createElement(Component, Object.assign({}, rest, props[`${screenSize}Props`]));
};
exports.ResponsiveLayout = ResponsiveLayout;
exports.ResponsiveLayout.displayName = 'ResponsiveLayout';
